import { render, staticRenderFns } from "./PartnersSection.vue?vue&type=template&id=597ecc18&scoped=true"
import script from "./PartnersSection.vue?vue&type=script&lang=js"
export * from "./PartnersSection.vue?vue&type=script&lang=js"
import style0 from "./PartnersSection.vue?vue&type=style&index=0&id=597ecc18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597ecc18",
  null
  
)

export default component.exports